import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import AccessList from "../Components/Access List/listAccess";

const AccessListRoutes = () => {
  const currentRole = useSelector((state) => state?.admin?.admin?.data?.role);
  const rehydrated = useSelector((state) => state?._persist?.rehydrated);

  // ✅ Wait for persist to restore role before redirecting
  if (!rehydrated) return null;

  return (
    <Routes>
      <Route path="/access_list" element={
          currentRole === "super_admin"
            ? <AccessList />
            : <Navigate to="/dashboard" replace />
        }
      />
    </Routes>
  );
};

export default AccessListRoutes;